import { useState, useEffect, useCallback } from "react";
import { getSacredEntry } from "@/lib/sacred-library/utils/registry";
import { fetchMergedSacredEntry, loadLinkRegistryFromApi } from "@/lib/sacred-library/sacred-library-api";
import { getRelatedTopics } from "@/lib/sacred-library/utils/link-registry";

export function useSacredEntry(type, id) {
  const [entry, setEntry] = useState(null);
  const [loading, setLoading] = useState(true);
  const [related, setRelated] = useState([]);

  const reload = useCallback(async () => {
    if (!type || !id) return;
    setLoading(true);
    await loadLinkRegistryFromApi();
    const merged = await fetchMergedSacredEntry(type, id);
    setEntry(merged ?? getSacredEntry(type, id));
    setRelated(getRelatedTopics(type, id));
    setLoading(false);
  }, [type, id]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { entry, loading, related, reload };
}
